module.exports = __webpack_public_path__ + "img/icon_card9.c184548f.png";